import React from "react";
import { NavLink } from "react-router-dom";
import "../Style/home&about.css";
import NavbarTag from "react-bootstrap/Navbar";

const Home = () => {
  return (
    <div className="main-section home-page">
      <section>
        <NavbarTag expand="lg">
          <NavLink end to="/" className="listItem" activeclassname="activeItem">
            Home
          </NavLink>
          <NavLink to="/about" className="listItem" activeclassname="activeItem">
            About
          </NavLink>
          <NavLink to="/contact" className="listItem" activeclassname="activeItem">
            Contact
          </NavLink>
          <NavLink to="/products" className="listItem" activeclassname="activeItem">
            Products
          </NavLink>
          <NavLink to="/services" className="listItem" activeclassname="activeItem">
            Services
          </NavLink>
        </NavbarTag>
      </section>

      <div id="home-overview" className="home-hero-banner">
        <div className="home-hero-banner-inner">
          <div className="home-hero-banner-title">
            <h1 className="home-hero-banner-heading">
              A Self-Aware Kubernetes Cluster
            </h1>
          </div>
          <div className="home-hero-banner-copy">
            <p>
              Our mission is to use Large Language Models to make {" "}
              <span className="home-hero-text-highlight">the reasoning</span>{" "} 
              of your kubernetes cluster automated and transparent.
              <br />
              Your cluster <span className="home-hero-text-highlight">tells everything</span> there is to know about the system of your system. From your applications, persistent storage, network, security, and more. 
              <br />
              Forget of all the observability, monitoring, alerting and other tools that consume all of your time and resources.
              <br />
              Start using our solution to make your cluster self-aware.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
